
import { useEffect, useState } from 'react';
import ApiService from './../../../services/ApiService';
import Connector from '../../../actions/Connector';
import MainContent from '../../../components/MainContent';
import Navigation from '../../../components/navigation';
import MenuButton from '../../../components/MenuButton';

function ConnectorPage() {
    const [user, setUser] = useState(false);

    useEffect(() => {

        if (document.getElementById("connector")) document.getElementById("connector").style.height = window.innerHeight / 100 * 7 > 55 ? (window.innerHeight - 65) + 'px' : window.innerHeight - (window.innerHeight / 100 * 7) - 10 + 'px';
        if (document.getElementById("RightPage")) document.getElementById("RightPage").style.height = window.innerHeight / 100 * 7 > 55 ? (window.innerHeight - 55) + 'px' : window.innerHeight - (window.innerHeight / 100 * 7) - 10 + 'px';

        ApiService.userinfo().then((response) => {
            setUser(response.user)
        });

    }, [])
    return (<>
        <Navigation user={user} />
        <MenuButton />
        <div id="RightPage">
            <MainContent />
            <Connector />
        </div>
    </>
    )
}
export default ConnectorPage